import { PLANNINGS_PATH } from 'installations/navigation';

const indexComponent = require('./routes/index/components/InstallationPlannings');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: PLANNINGS_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationPlannings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/plannings/index.js